"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormControlMessage = _interopRequireDefault(require("../FormControlMessage"));

var _FormGroup = _interopRequireDefault(require("../FormGroup"));

var _Label = _interopRequireDefault(require("../Label"));

require("./Textarea.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Always use labels on text areas and don’t depend on the placeholder text.
 * If there is more information for the text area needed make
 * use of a paragraph on top or use an info box. */
function Textarea(props) {
  var label = props.label,
      labelInfobox = props.labelInfobox,
      disabled = props.disabled,
      required = props.required,
      error = props.error,
      children = props.children,
      helpText = props.helpText,
      rest = _objectWithoutProperties(props, ["label", "labelInfobox", "disabled", "required", "error", "children", "helpText"]);

  return /*#__PURE__*/_react.default.createElement(_FormGroup.default, {
    disabled: disabled,
    error: error
  }, label && /*#__PURE__*/_react.default.createElement(_Label.default, {
    htmlFor: label,
    label: label,
    labelInfobox: labelInfobox,
    required: required,
    helpText: helpText
  }), /*#__PURE__*/_react.default.createElement("textarea", _extends({}, rest, {
    id: label,
    className: "Textarea",
    disabled: disabled,
    required: required
  })), error && /*#__PURE__*/_react.default.createElement(_FormControlMessage.default, null, error), children && /*#__PURE__*/_react.default.createElement("p", null, children));
}

Textarea.propTypes = {
  /** The label text */
  label: _propTypes.default.string,

  /** The text displayed if the label tooltip exist */
  labelInfobox: _propTypes.default.bool,

  /** Whether the input is disabled */
  disabled: _propTypes.default.bool,

  /** If required field* */
  required: _propTypes.default.bool,

  /** The error message displayed if the input is errored */
  error: _propTypes.default.string,

  /** @ignore */
  defaultValue: _propTypes.default.string,

  /** @ignore */
  children: _propTypes.default.node,

  /** The text displayed if the label tooltip exist */
  helpText: _propTypes.default.bool
};
Textarea.defaultProps = {
  label: null,
  labelInfobox: false,
  disabled: false,
  required: false,
  error: null,
  defaultValue: null,
  children: null,
  helpText: null
};
var _default = Textarea;
exports.default = _default;